<template>
  <div class="job-card" :class="payload['option-listing-type'].toLowerCase()" @click="handleInputToggle">

    <input :id="payload['objectID']" class="job-card__input" type="radio" name="job-card__input" ref="card__input">

    <label :for="payload['objectID']">

      <!-- left -->
      <div class="job-card__left">
        <div class="job-card__logo-container">
          <img class="job-card__logo" :src="$filters.analyseImage(payload['org-logo'], 'logosm', 'logoxl')" :alt="payload['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
        </div>

        <!-- popup panel on logo hover -->
        <div class="job-card__hover-panel">
          <div class="job-card__hover-panel-header">
            <div class="job-card__logo-container">
              <img class="job-card__logo" :src="$filters.analyseImage(payload['org-logo'], 'logosm', 'logoxl')" :alt="payload['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
            </div>
            <block-alert-button classes="job-card__hover-panel-create-alert" :org_main_id="payload['org-main-id']" :org_name="payload['org-name']"></block-alert-button>
          </div>
          <div class="job-card__hover-panel-body">
            <h4 v-if="payload['org-name']" class="job-card__hover-panel-org-name"><a :href="`/organisation/redirect/${payload['org-main-id']}`">{{ payload['org-name'] }}</a></h4>
            <p>{{ payload['date-published'] }}</p>
            <ul v-if="payload['option-esc-factor'] && payload['option-esc-factor'] != ''" class="job-card__hover-panel-factors">
              <li v-for="factor in payload['option-esc-factor']" :key="factor">
                {{ factor }}
              </li>
            </ul>
            <p v-if="payload['org-summary'] && payload['org-summary'] != ''" class="job-card__hover-panel-org-summary">{{ payload['org-summary'] }}</p>
          </div>
          <div class="job-card__hover-panel-footer">
            <div v-if="payload['listings-live-public'] && payload['listings-live-public'] != ''" class="job-card__hover-panel-bottom-jobs">
              <a :href="searchLink">
                {{ payload['listings-live-public'] }} <span>Roles</span>
              </a>
            </div>
            <div v-if="payload['review-count'] && payload['review-count'] != ''" class="job-card__hover-panel-bottom-reviews">
              {{ payload['review-count'] }} <span>Reviews</span>
            </div>
          </div>
        </div>
      </div>

      <!-- right -->
      <div class="job-card__right">
        <div :class="['job-card__right-inner', {'can-hover':checkHoverSupport}]">

          <div class="job-card__right-top">
            <div class="job-card__right-content-left">

              <h3 v-if="payload['job-title']" class="job-card__title">{{ payload['job-title'] }}</h3>

              <div class="job-card__right-group">
                <p v-if="payload['org-name']" class="job-card__org-name">{{ payload['org-name'] }}</p>

                <p v-if="payload['av-nps'] && payload['review-count']" class="job-card__org-review">
                  <svg class="job-card__org-review-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12"><path d="M4.453 4.031l.797-1.875L6.422 0l2.11 3.703 2.671.328 1.64.188-3.327 3.515 1.171 4.22-2.25-1.454L6.47 9.14 2.906 11.72 2.11 12l1.079-4.5L0 4.172l1.828-.188 2.625.047z" fill="#F9AE13"/></svg>
                  {{$filters.toFixed(payload['av-nps'])}} <span>({{(payload['review-count']) ? payload['review-count'] : 0}})</span>
                </p>

                <div v-if="payload['location-txt']" class="job-card__location">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 9 13.4">
                    <path fill="#5c6e7e" d="M4.3 12.5c0 .1.1.1.2.1s.1 0 .2-.1c.5-1.1 1.3-2.2 2.1-3.3C7.9 7.6 9 6 9 4.5 9 2.9 8.1 1.4 6.7.6 5.3-.2 3.6-.2 2.2.6.9 1.4 0 2.9 0 4.5 0 6 1.1 7.6 2.3 9.2c.7 1.1 1.5 2.2 2 3.3zM4.5.4c1.1 0 2.2.4 2.9 1.2s1.2 1.8 1.2 2.9c0 1.4-1.1 2.9-2.2 4.5-.7 1-1.4 2-1.9 3-.5-1-1.2-2-1.9-3C1.4 7.4.4 5.9.4 4.5c0-1.1.4-2.2 1.2-2.9C2.4.8 3.4.4 4.5.4zm0 6.7a2.732 2.732 0 0 0 2.7-2.7c0-.7-.3-1.4-.8-1.9-.5-.3-1.2-.6-1.9-.6s-1.4.3-1.8.8c-.5.4-.8 1.1-.8 1.8s.3 1.4.8 1.9c.4.5 1.1.7 1.8.7zm0-4.9c.6 0 1.2.2 1.6.7.4.4.7 1 .7 1.6 0 .6-.2 1.2-.7 1.6-.4.4-1 .7-1.6.7s-1.2-.3-1.6-.7c-.4-.4-.7-1-.7-1.6 0-.6.2-1.2.7-1.6.4-.4 1-.7 1.6-.7zm4 9.8c0 .4-.4.8-1.2 1-.9.3-1.8.4-2.8.4-.9 0-1.9-.1-2.8-.4-.8-.3-1.2-.6-1.2-1 0-.5.8-1 2.1-1.2.1 0 .2 0 .2.1s0 .2-.1.2c-1.2.2-1.8.6-1.8.9 0 .4 1.4 1 3.6 1s3.6-.6 3.6-1c0-.3-.6-.6-1.8-.9 0 0-.1 0-.1-.1v-.1s0-.1.1-.1h.1c1.3.2 2.1.7 2.1 1.2z"/>
                  </svg>
                  {{ payload['location-txt'] }}
                </div>
              </div>

              <p v-if="payload['org-summary'] && payload['org-summary'] != ''" :class="['job-card__org-summary', {'is1pct': payload['top1percent']} ]">{{ payload['org-summary'] }}</p>

              <!-- tags -->
              <div class="tab-list">
                <div v-if="payload['option-listing-type']" class="listing-type">
                  <p>{{ payload['option-listing-type'] }}</p>
                </div>

                <div v-if="payload['featured-tags'] && payload['featured-tags'][0]" class="tag">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 11 11.1"><path d="m11 .1-.1-.1s-.1 0-.1.1L9.6 1.2H5.9c-.3 0-.6.1-.8.3L.3 6.3c-.4.3-.5.9-.1 1.3l3.2 3.2c.2.2.4.3.6.3h.1c.3 0 .5-.2.7-.3L9.5 6c.2-.2.3-.5.3-.8V1.5L11 .4l.1-.1-.1-.2zM4.5 10.4c-.1.1-.3.2-.4.2-.1 0-.2 0-.3-.1L.5 7.3c-.2-.1-.1-.5.1-.7l.4-.4L4.9 10l-.4.4zm5-5.2c0 .2-.1.4-.2.5l-4 4-3.9-3.9 4-4c.1-.1.3-.2.5-.2h3.6v3.6z"/></svg>
                  {{ payload['featured-tags'][0] }}
                </div>
                <div v-if="payload['featured-tags'] && payload['featured-tags'][1]" class="tag">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 11 11.1"><path d="m11 .1-.1-.1s-.1 0-.1.1L9.6 1.2H5.9c-.3 0-.6.1-.8.3L.3 6.3c-.4.3-.5.9-.1 1.3l3.2 3.2c.2.2.4.3.6.3h.1c.3 0 .5-.2.7-.3L9.5 6c.2-.2.3-.5.3-.8V1.5L11 .4l.1-.1-.1-.2zM4.5 10.4c-.1.1-.3.2-.4.2-.1 0-.2 0-.3-.1L.5 7.3c-.2-.1-.1-.5.1-.7l.4-.4L4.9 10l-.4.4zm5-5.2c0 .2-.1.4-.2.5l-4 4-3.9-3.9 4-4c.1-.1.3-.2.5-.2h3.6v3.6z"/></svg>
                  {{ payload['featured-tags'][1] }}
                </div>

                <job-card-smart-time :posted_date="payload['posted-date']" :job_id="payload['objectID']"></job-card-smart-time>
              </div>
            </div>

            <div class="job-card__right-content-right">

              <div class="job-card__right-content-right-top">
                <div v-if="payload['option-listing-type']" class="listing-type">
                	<p>{{ payload['option-listing-type'] }}</p>
                </div>
                <job-card-smart-time :posted_date="payload['posted-date']" :job_id="payload['objectID']"></job-card-smart-time>
								<!-- Top 1% Employer TODO: isTop1PercentEmployer -->
								<img v-if="payload['top1percent']" src="/images/top-1-percent.svg" alt="Top 1% Employer" class="badge-top-1-percent">
              </div>

              <div class="job-card__right-content-right-bottom">
                <div class="job-card__right-actions">
                  <block-action-bookmark-job :job_id="payload['objectID']" class="btn btn-applied btn-small">Save</block-action-bookmark-job>
                  <a :href="jobLink" class="btn btn-blue-dark btn-small">
                    {{ btnLabel(payload['option-listing-type']) }}
                    <svg-chevron-left></svg-chevron-left>
                  </a>
                </div>
              </div>

            </div>
          </div>

          <div class="job-card__right-bottom">
            <div class="job-card__right-bottom-inner">

              <div class="job-card__right-bottom-top">
                <!-- salary -->
                <div class="job-card__salary-group">

									<template v-if="payload['option-listing-type'] && payload['option-listing-type'].toLowerCase() === 'volunteer'">
										<div class="job-card__volunteer-icon-container">
											<svg viewBox="0 0 100 100" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
												<path d="M69 65.2v-22c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v-8.8c0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.9 1.7-3.9 3.9v-2.8c0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.9 1.7-3.9 3.9v5.9c0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.9 1.7-3.9 3.9v17.2c0-2.4-2.2-6-4.7-6-2.7 0-3.2 2.4-3.2 5.6v10.4c0 3 .7 5.8 1.9 8.3l17 16.4 17.4-16.8c1.2-2.3 1.8-4.8 1.8-7.4z" fill-rule="evenodd" clip-rule="evenodd" fill="#f9cc9f"/>
												<path d="m50 20.9-3.4-3.3C37.4 9 22.8 7.7 14 16.8c-10 10.5-10 27.5 0 38L33 73c-1.2-2.5-1.9-5.3-1.9-8.3V54.3c0-3.2.6-5.6 3.2-5.6 2.5 0 4.7 3.5 4.7 6V37.5c0-2.1 1.7-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9v-5.9c0-2.1 1.7-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9v2.8c0-2.1 1.7-3.9 3.9-3.9 2.1 0 3.9 1.7 3.9 3.9v8.8c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4v22c0 2.7-.6 5.2-1.5 7.5l18.5-17.9c9.8-10.5 9.8-27.5-.3-38-8.7-9.1-23.3-7.8-32.5.8L50 20.9z" fill-rule="evenodd" clip-rule="evenodd" fill="#ed5565"/>
												<path d="M87 15.8c-8.9-9.2-24.4-8.9-34.6.7L50 18.8l-2.4-2.3C37.4 6.9 21.8 6.6 13 15.8c-10.6 11-10.6 29 0 40l36 34.7c.3.3.7.4 1 .4s.8-.1 1-.4l36-34.7c10.7-11 10.7-29 0-40zM50 87.4 34.2 72.1c-1.1-2.3-1.7-4.8-1.7-7.4V54.3c0-4.1 1-4.1 1.7-4.1 1.5 0 3.2 2.7 3.2 4.5v7.8s0 .1.1.1c0 0 0 .1.1.1l.1.1.1.1.1.1.1.1.1.1s.1 0 .1.1c0 0 .1 0 .2.1h.1c2.4.6 5 3.5 5 6.9 0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-4.4-2.9-8-6.1-9.4V37.5c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v16.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V31.6c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4v23.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-21c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4v19.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-11c0-1 .8-1.9 1.9-1.9 1 0 1.9.9 1.9 1.9v22c0 2.3-.5 4.5-1.3 6.6L50 87.4zm34.9-33.7L70.3 67.8c.1-.9.2-1.7.2-2.6v-22c0-2.7-2.2-4.9-4.9-4.9-.7 0-1.3.1-1.9.4v-4.2c0-3-2.4-5.4-5.4-5.4-1 0-1.9.3-2.7.8-.7-2.1-2.7-3.6-5.1-3.6-3 0-5.4 2.4-5.4 5.4v1.1c-.7-.4-1.5-.6-2.4-.6-3 0-5.4 2.4-5.4 5.4v11c-.9-.8-2-1.3-3.2-1.3-4.7 0-4.7 5.3-4.7 7.1v10.4c0 1.1.1 2.1.2 3.2L15.1 53.7c-9.5-9.9-9.5-26 0-35.8 3.7-3.9 8.9-5.8 14.2-5.8 5.7 0 11.6 2.2 16.2 6.6l3.4 3.3c.6.6 1.5.6 2.1 0l3.4-3.3c9-8.4 22.7-8.8 30.4-.8 9.6 9.9 9.6 25.9.1 35.8z"/>
											</svg>
										</div>
										<p class="job-card__salary-text">Volunteer role</p>
									</template>

                  <template v-else>
										<div class="job-card__salary-icon-container">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" fill="#5c6f7e">
												<path d="M9.5 0C7 0 4.6 1 2.8 2.8 1 4.6 0 7 0 9.5s1 4.9 2.8 6.7C4.6 18 7 19 9.5 19s4.9-1 6.7-2.8C18 14.4 19 12 19 9.5s-1-4.9-2.8-6.7S12 0 9.5 0zm0 18c-2.3 0-4.4-.9-6-2.5-1.6-1.6-2.5-3.7-2.5-6s.9-4.4 2.5-6C5.1 1.9 7.2 1 9.5 1s4.4.9 6 2.5c1.6 1.6 2.5 3.8 2.5 6 0 2.3-.9 4.4-2.5 6-1.6 1.6-3.7 2.5-6 2.5z" class="st0"/>
												<path d="m12.5 13-.5.2c-.5.2-1 .1-1.5-.1-.6-.3-1.2-.4-1.8-.4l.3-1.2v-1h1.4c.5 0 .8-.4.8-.8s-.4-.8-.8-.8H8.8c0-.2-.1-.4-.1-.5-.1-.5-.2-.9-.2-1.3 0-.2 0-.4.1-.5.1-.2.2-.3.3-.4.1-.2.3-.3.4-.3.2-.1.4-.1.6-.1 1 0 1.2.5 1.3 1 0 .2.2.4.4.5.2.1.4.2.6.1.2 0 .4-.2.5-.4.1-.2.2-.4.1-.6-.3-1.4-1.4-2.3-2.9-2.3-.4 0-.8.1-1.2.2-.7.3-1.3.9-1.6 1.7-.2.3-.2.7-.2 1.1 0 .5.1 1 .2 1.5v.2H5.9c-.5 0-.8.4-.8.8 0 .5.4.8.8.8h1.4v.9c0 .5-.2.9-.5 1.3l-.4.5c-.2.3-.2.6 0 .9.2.3.5.4.8.4l1.4-.2c.4 0 .8 0 1.1.2.8.4 1.8.5 2.7.2l.5-.2c.4-.1.7-.6.5-1 0-.3-.5-.5-.9-.4z" class="st0"/>
											</svg>
										</div>
										<template v-if="hasSalary">
											<p v-if="payload['show-sal'] === false" class="job-card__salary-text estimated">
												<span>From ~ £{{ payload['salary-low'] }}</span>
												<span>(Esc estimated)</span>
											</p>
											<p v-if="payload['show-sal'] === true" class="job-card__salary-text verified">
												<span>From £{{ payload['salary-low'] }}</span>
												<span>
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.5 8.9" fill="#18b027">
														<path d="M3.7 8.9C3.5 8.8 0 7.2 0 5.2v-5C0 .1.1 0 .2 0h7.1c.1 0 .2.1.2.2v5c0 2.1-3.5 3.6-3.6 3.7h-.2zM.4.4v4.8c0 1.6 2.8 3 3.3 3.3C4.3 8.2 7 6.8 7 5.2V.4H.4z" class="st0"/>
														<path d="M3 5.5s-.1 0-.1-.1l-1.2-1c-.1-.1-.1-.2 0-.3s.2-.1.3 0L3 5l2.5-2.5c.1-.1.2-.1.3 0 .1.1.1.2 0 .3L3.2 5.5H3z"/>
													</svg>
													Employer verified
												</span>
											</p>
										</template>
										<template v-else>
											<p v-if="payload['option-listing-type'] !== 'Volunteer'" class="job-card__salary-text">Enquire</p>
											<p v-else class="job-card__salary-text">Volunteer</p>
										</template>
                  </template>
                </div>

                <!-- team -->
                <div v-if="payload['option-size']" class="job-card__team">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 12.8" fill="#5c6f7e">
                    <path d="M9.5 2.1c1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4zm0 .6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.7-.8 1.7-1.8c.1-1-.7-1.8-1.7-1.8zM14.9 0c1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4zm0 .6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.7-.8 1.7-1.8c.1-1-.7-1.8-1.7-1.8z" class="st0"/>
                    <path d="M4.1 5.3c1.7 0 3.1 1 3.7 2.4.5-.3 1.1-.4 1.7-.4.6 0 1.2.1 1.7.4.6-1.5 2-2.4 3.7-2.4 2.2 0 3.9 1.7 4.1 3.9 0 .4-.2.7-.6.8-1.2.5-2.3.7-3.5.7-.5 0-1 0-1.5-.1.1.2.1.5.1.7 0 .4-.2.7-.6.8-1.2.5-2.3.7-3.5.7-1.2 0-2.4-.2-3.6-.7-.3-.1-.6-.5-.5-.8 0-.2.1-.5.1-.7-.5.1-1 .1-1.5.1-1.2 0-2.3-.2-3.5-.7-.2-.1-.4-.4-.4-.8C.2 7 1.8 5.3 4.1 5.3zm7.7 2.8c.7.5 1.2 1.1 1.5 1.9.6.1 1.1.2 1.7.2 1.1 0 2.2-.2 3.3-.6.1-.1.2-.1.2-.2-.3-2-1.6-3.4-3.6-3.4-1.4 0-2.6.8-3.1 2.1zm-4.6 0C6.7 6.8 5.6 6 4.1 6 2.1 6 .8 7.4.6 9.3c0 .1.1.2.1.2 1.1.4 2.2.6 3.3.6.6 0 1.1-.1 1.7-.2.4-.7.9-1.4 1.5-1.8zm2.3 0c-1.9 0-3.3 1.4-3.4 3.3 0 .1 0 .2.1.2 1.1.4 2.2.6 3.3.6 1.1 0 2.2-.2 3.3-.6.1-.1.2-.1.2-.2-.2-1.9-1.6-3.3-3.5-3.3zM4.1 0c1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4C1.7 1.1 2.8 0 4.1 0zm0 .6c-1 0-1.7.8-1.7 1.8s.8 1.8 1.7 1.8c1 0 1.8-.8 1.8-1.8-.1-1-.8-1.8-1.8-1.8z" class="st0"/>
                  </svg>
                  <p>{{ payload['option-size'] }}</p>
                </div>

                <!-- roles -->
                <a :href="searchLink">
                  <div v-if="payload['listings-live-public']" class="job-card__roles">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.8 11.4" fill="#5c6f7e">
                      <path d="M1.4 0C.6 0 0 .6 0 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4S2.2 0 1.4 0zm-.1 1.4s.1-.1 0 0c.1-.1.2-.1.2 0 0 .2-.2.2-.2 0zM1.4 4.2C.6 4.2 0 4.9 0 5.7s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.5-1.4-1.5zm-.1 1.5c0-.1.1-.1 0 0 .1-.1.2-.1.2 0s-.2.1-.2 0zM1.4 8.5C.6 8.5 0 9.1 0 9.9s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4zm-.1 1.4s.1-.1 0 0c.1-.1.2-.1.2 0s-.2.1-.2 0zM4.7 2.2H16c.4 0 .8-.3.8-.8s-.4-.7-.8-.7H4.7c-.4 0-.8.3-.8.7s.4.8.8.8zM16 4.9H4.7c-.4 0-.8.3-.8.8 0 .4.3.8.8.8H16c.4 0 .8-.3.8-.8 0-.4-.4-.8-.8-.8zM16 9.2H4.7c-.4 0-.8.3-.8.8 0 .4.3.8.8.8H16c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z" class="st0"/>
                    </svg>
                    <p>{{ payload['listings-live-public'] }} Roles</p>
                  </div>
                </a>
              </div>

              <div class="job-card__right-bottom-middle">
                <p v-if="payload['headline'] && payload['headline'] != ''" class="job-card__headline">{{ payload['headline'] }}</p>
              </div>

              <div class="job-card__right-bottom-bottom">
                <div class="job-card__right-actions">
                  <block-action-bookmark-job :job_id="payload['objectID']" class="btn btn-applied btn-small">Save</block-action-bookmark-job>
                  <a :href="jobLink" class="btn btn-blue-dark btn-small">
                    {{ btnLabel(payload['option-listing-type']) }}
                    <svg-chevron-left></svg-chevron-left>
                  </a>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </label>

  </div>
</template>

<script>
import AuthMixins from '@/mixins/AuthMixins';
import JobCardSmartTime from './partials/JobCardSmartTime';

export default {
  mixins: [AuthMixins],

	components: {
		JobCardSmartTime
	},

  props: {
    payload: {
      type: Object,
      default: {}
    },
		from: {
			type: String,
			default: ''
		}
  },

  data() {
    return {
      application: null,
      checked: false
    }
  },
	created() {
		this.emitter.on("deselect:job:cards", this.deselect);
	},
	beforeUnmount() {
		this.emitter.off("deselect:job:cards", this.deselect);
	},

  mounted() {
    console.log('JobCard:', this.payload);

    if (this.me) {
      this.application = this.me.applications.find(a => a['job-id'] === this.payload.objectID);
    }
  },

  methods: {
		deselect(objectID) {
			if (this.payload.objectID !== objectID) {
				this.checked = false;
				this.$refs.card__input.checked = false;
			}
		},
    handleInputToggle(e) {
      if (e.target.classList.contains('job-card__input')) {
        this.emitter.emit("deselect:job:cards", this.payload.objectID);
				if (this.checked == false) {
					e.target.checked = true;
          this.checked = true;
					this.trackJobExpand();
        } else {
          e.target.checked = false;
          this.checked = false;
        }
      }
    },
		trackJobExpand() {
			let payload = {'job_id':this.payload.objectID}
			return this.$api.trackJobExpand(payload).then(
				(response) => {
					if (response.data.status == 'success') {
						console.log('doTrack:trackJobExpand', response.data.status);
					}
				}
			).catch((response) => {
				console.log("Could not track view.", response);
			});
		},
    btnLabel(type) {
      switch (type.toLowerCase()){
        case 'job':
        case 'internship':
          return 'View job'
          break;
        case 'project':
          return 'View project'
          break;
        case 'volunteer':
          return 'View role'
          break;
        default:
          return 'View'
      }
    }
  },

  computed: {
    searchLink() {
			var query_array = ["org-name="+this.payload['org-name']];
			var query = query_array.join("&");
			// Needs to be double encoded, don't know why!
			return '/search/jobs?q='+encodeURIComponent(encodeURIComponent(query));
		},
    statusApply() {
      return (!this.statusInProgress && !this.statusReviewing && !this.statusRejected) ? true : false;
    },
    statusInProgress() {
      if (this.application && this.application['invited-to-interview']) {
        return this.application['invited-to-interview'];
      }
      return false;
    },
    statusReviewing() {
      if (this.application && this.application['invited-to-next-stage']) {
        return this.application['invited-to-next-stage'];
      }
      return false;
    },
    statusRejected() {
      if (this.application && this.application['not-successful']) {
        return this.application['not-successful'];
      }
      return false;
    },
		checkHoverSupport() {
			// Check for hover: hover media feature
			const hoverQuery = window.matchMedia('(hover: hover)');
			// Check for any-pointer: fine media feature
			const finePointerQuery = window.matchMedia('(pointer: fine)');

			return hoverQuery.matches && finePointerQuery.matches;
		},
		jobLink() {
			let path = ''
			if (this.payload['slug'] == undefined) {
				path = `/opportunity/redirect/${this.payload['objectID']}`;
			} else {
				path = `/opportunity/${this.payload['slug']}`;
			}

			if (this.from !== '') {
				path += `?from=${this.from}`;
			}

			return path;
		},
		hasSalary() {
			return (this.payload['salary-low'] !== null && this.payload['salary-low'] !== 0)
		},
		isTop1PercentEmployer() {
			// TODO
			return new Date(this.payload['certification']) > new Date();
		}
  }
}
</script>

